import { useEffect, useRef } from 'react';

/**
 * Calls `onAutoSave()` when the component unmounts.
 * Useful for preserving react-hook-form state when users navigate away (via stepper).
 */
export const useAutoSaveFormOnUnmount = (onAutoSave?: () => void) => {
  const onAutoSaveRef = useRef(onAutoSave);

  useEffect(() => {
    onAutoSaveRef.current = onAutoSave;
  });

  useEffect(
    () => () => {
      if (!onAutoSaveRef.current) return;
      try {
        onAutoSaveRef.current();
      } catch (error) {
        console.log('error on auto save', error);
      }
    },
    [],
  );
};
